import Layout from "@/views/layout/index";

const helpCenter = [
  {
    path: "/helpCenter",
    name: "helpCenter",
    isChildren: false,
    hidden: true,
    component: Layout,
    mCode:"BZZX",
    meta: { title: '帮助中心', icon: 'el-icon-s-help' },
    children: [
      {
        path: '/helpCenter',
        component: () => import('@/views/helpCenter/index'),
      }
    ]
  },
  {
    path: "/lawDetail",
    name: "LawDetail",
    hidden: true,
    component: Layout,
    isChildren: false,
    meta: { title: '帮助详情', icon: 'el-icon-s-help' },
    children: [
      {
        path: '/lawDetail',
        component: () => import('@/views/helpCenter/detail.vue'),
      }
    ]
  }
]

export default helpCenter



// WEBPACK FOOTER //
// ./src/router/helpCenter/index.js